import { useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import Slider from "react-slick";
import { AlertCircle, BulbIcon, DownloadIcon, RoundDateIcon, ViewIcon } from "../../../../../assets/icons/svgicons";
import firstCard from "../../../../../assets/images/firstCard.svg";
import secCard from "../../../../../assets/images/secCard.svg";
import Button from "../../../../common/Button/Button";
import AmountDetails from "../AmountDetails/AmountDetails";
import styles from "./CardStatement.module.scss";
import { cardDetailsAction, getCardStatementAction } from "../../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { format, startOfMonth, subMonths } from "date-fns";
import PaynowModal from "../PaynowModal/PaynowModal";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../routes";
import PaymentDetails from "../PaymentDetails/PaymentDetails";
import CommonDatePicker from "../../../../common/Formik/DatePiker/DatePicker";
import { Formik } from "formik";

const CardStatement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false)
  const [startDate, setStartDate] = useState("");
  const [cardDetails, setCardDetails] = useState({});
  const [cardStatementData, setCardStatementData] = useState(null);
  const [activeTab, setActiveTab] = useState("cardStatement");
  const Data = [
    {
      classcard: "",
      label: "Total Outstanding Amount",
      values: "$" + cardStatementData?.new_balance || 0,
      description: "",
    },
    {
      classcard: "light_red",
      label: "Status",
      values: cardStatementData?.status || "N/A",
      description: "",
    },
  ];
  const Data2 = [
    {
      classcard: "light_blue",
      label: "Amount Paid",
      values: "$" + cardStatementData?.total_payments || 0,
      description: "",
    },
    {
      classcard: "light_red",
      label: "Payment Date",
      values: cardStatementData?.due_date ? format(new Date(cardStatementData?.due_date), "dd MMM, yyyy") : "--",
      description: "",
    },
  ];
  const settings = {
    dots: false,
    infinite: false,
    arrow: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        arrow: true,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // ********** GET CARD DETAILS **********
  const getCardDetails = async () => {
    try {
      const res = await dispatch(cardDetailsAction());
      if (res?.status === 200) {
        const cards = res?.data?.data || [];
        const debit = cards.find((c) => c.card_type === "DEBIT");
        const credit = cards.find((c) => c.card_type === "CREDIT");
        setCardDetails({ debit: debit, credit: credit })
      } else {
        setCardDetails({});
      }
    } catch (error) {
      console.log(error, "error");
    }
  }
  const cardId = cardDetails?.credit?.rain_card_id;

  useEffect(() => {
    getCardDetails()
  }, [])
  useEffect(() => {
    if (cardId) {
      getCardStatement()
    }
  }, [cardId, startDate])

  const getCardStatement = async () => {
    try {
      const payload = {
        ...(startDate && {
          month: format(new Date(startDate), "MM"),
          year: format(new Date(startDate), "yyyy"),
        }),
      }
      const res = await dispatch(getCardStatementAction(payload, cardId))
      if (res?.status === 200) {
        setCardStatementData(res?.data?.data)
      }
    } catch (error) {
      console.log(error, "error");
    }
  }

  const handlePrintPDF = () => {
    window.print();
  };

  return (
    <>
      <section className={styles.CardStatement}>
        {/* <div className={styles.CardStatement_head}>
          <img src={secCard} className={styles.Card} alt="cards" />
          <img src={firstCard} className={styles.Card} alt="cards" />
        </div> */}
        {/* {activeTab !== 'cardStatement' && <div className={styles.AmountDetails_content}>
          <Row>
            <Col lg={6}>
              <div className={styles.AmountDetails_content_left}>
                <h4 className={styles.heading}>Balance Details</h4>
                <ul>
                  <li>
                    <label>Unbilled Amount</label>
                    <h4>$5,148.56</h4>
                  </li>
                  <li>
                    <label>Outstanding Amount </label>
                    <h4>$11,879.75</h4>
                  </li>

                </ul>
              </div>
            </Col>
            <Col lg={6}>
              <div className={styles.AmountDetails_content_right}>
                <h4 className={styles.heading}>Available Limits</h4>
                <ul className={styles.light_blue}>
                  <li>
                    <label>Credit Limit</label>
                    <h4>$67,148.56</h4>
                  </li>
                  <li>
                    <label>Cash Limt</label>
                    <h4>$23,000.00</h4>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
        } */}
        <div className={styles.CardStatement_tabNavs}>
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeTab}
            // onSelect={(key) => {
            //   setActiveTab(key);
            //   if (key === "marketplace") {
            //     getTransactions();
            //   } else if (key === "deposits") {
            //     depositHistory();
            //   } else if (key === "withdrawals") {
            //     withdrawHistory();
            //   }
            // }}
            onSelect={(key) => setActiveTab(key)}
            className="tabContainer"
          >
            <div className="tabHeaderb">
              <Nav variant="pills" className="navTabs">
                <Slider {...settings}>
                  <Nav.Item>
                    <Nav.Link eventKey="cardStatement">Card Statement</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="unbilledTransactions">Unbilled Transactions</Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                    <Nav.Link eventKey="transactionHistory">Transaction History</Nav.Link>
                  </Nav.Item> */}
                  <Nav.Item>
                    <Nav.Link eventKey="paymentHistory">Payment History</Nav.Link>
                  </Nav.Item>
                </Slider>
              </Nav>
            </div>
            <Tab.Content>
              <Tab.Pane eventKey="cardStatement">
                {cardStatementData ?
                  <>
                    <div className={styles.CardStatement_content}>
                      <Row>
                        <Col lg={6} className="card_col">
                          {" "}
                          <div className={styles.CardStatement_content_left}>
                            <h4 className={styles.heading}>Amount Due</h4>
                            <Row>
                              {Data.map((items, index) => (
                                <Col lg={6} md={6} xs={12} key={index} className="card_col">
                                  <div
                                    className={`${styles.cardtransaction} ${items.classcard}`}
                                  >
                                    <div className={styles.text_sec}>
                                      <label>{items.label}</label>
                                      <h4 className="big">{items.values}</h4>
                                      <p>{items.description}</p>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </Col>
                        <Col lg={6} className="card_col">
                          {" "}
                          <div className={styles.CardStatement_content_left}>
                            <h4 className={styles.heading}>Last Payment Details</h4>
                            <Row>
                              {Data2.map((items, index) => (
                                <Col lg={6} md={6} xs={12} key={index} className="card_col">
                                  <div
                                    className={`${styles.cardtransaction} ${items.classcard}`}
                                  >
                                    <div className={styles.text_sec}>
                                      <label>{items.label}</label>
                                      <h4 className="big">{items.values}</h4>
                                      <p>{items.description}</p>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className={styles.CardStatement_content_bottom}>
                      <div className={styles.CardStatement_content_bottom_action}>
                        {/* <Button variant="bordered_grey">Setup Auto Debit</Button> */}
                        <Button onClick={() => setShow(true)}>Pay Now</Button>
                      </div>
                      <Row>
                        <Col lg={6}>
                          <div className={styles.statement_card}>
                            <div className={styles.statement_card_head}>
                              <h4>Statement Overview</h4>
                              {/* <h6>
                                20-Nov-2025
                                <span>
                                  <RoundDateIcon />
                                </span>
                              </h6> */}
                              <Formik
                                initialValues={{
                                  startdate: "",
                                }}
                                onSubmit={(values) => console.log("Form Submitted:", values)}
                              >
                                {(formik) => (
                                  <CommonDatePicker
                                    className="cardDatePicker"
                                    name="startdate"
                                    value={startDate}
                                    placeholder="Enter Month"
                                    onChange={(date) => setStartDate(date)}
                                    formik={formik}
                                    showMonthYearPicker={true}
                                    minDate={startOfMonth(subMonths(new Date(), 2))}
                                    maxDate={new Date()}
                                  />
                                )}
                              </Formik>
                            </div>
                            <ul>
                              <li>
                                Previous<span>${cardStatementData?.previous_balance || 0}</span>
                              </li>
                              <li>
                                Debits & Purchases<span>${cardStatementData?.total_charges || 0}</span>
                              </li>
                              {/* <li>
                                Credits & Payment<span>${cardStatementData?.totalRefundAmount || 0}</span>
                              </li> */}
                              <li>
                                Interest Fees<span>${cardStatementData?.total_fees || 0}</span>
                              </li>
                            </ul>
                            <h5 className={styles.totel_value}>
                              Total Outstanding <span>${cardStatementData?.new_balance || 0}</span>
                            </h5>
                            <div className={styles.action_box}>
                              <Button
                                className={styles.without_bg_border}
                                variant="bordered_grey"
                                onClick={() => navigate(ROUTES.VIEW_STATEMENT)}
                              >
                                View Statement
                                <ViewIcon />
                              </Button>
                              <Button onClick={handlePrintPDF}>
                                Download PDF <DownloadIcon />
                              </Button>

                            </div>
                          </div>
                          {/* <div className={styles.statement_card}>
                        <div className={styles.statement_card_head}>
                          <h4>Cashback Summary</h4>
                        </div>
                        <ul>
                          <li>
                            Earned this month<span>0.00</span>
                          </li>
                          <li>
                            Earned this year<span>0.00</span>
                          </li>
                          <li>
                            Earned till date<span>0.00</span>
                          </li>
                        </ul>
                      </div> */}
                        </Col>
                        {/* <Col lg={6}>
                      <div className={styles.statement_card}>
                        <div className={styles.statement_card_head}>
                          <h4>Rewards Point Summary</h4>
                        </div>
                        <ul>
                          <li>Previous Balance<span>$2,040.50</span></li>
                          <li>Earned<span>$1,540.00</span></li>
                          <li>Redeemed<span>$0</span></li>
                        </ul>
                        <h6 className={styles.totel_value}>Closing Balance <span>$3,580.50</span></h6>
                        <div className={styles.expiring_box}>
                          <h6>
                            Points expiring by 31 DEC 2025 <span>0</span>
                          </h6>
                          <div className={styles.expiring_box_msg}>
                            <span><BulbIcon /></span>
                            <p>The Closing Balance has been arrived at after further deduction of expired reward points and / or other adjustment, if any</p>
                          </div>
                        </div>
                      </div>
                    </Col> */}
                      </Row>
                    </div>
                  </> :
                  <div className={styles.CardStatement_content}>
                    <Col lg={6} className="card_col">
                      {" "}
                      <div className={styles.CardStatement_content_left}>
                        <Row>
                          <Col lg={6} md={6} xs={12} className="card_col">
                            <div className={`${styles.cardnotyet}`}>
                              <div className={styles.text_sec}>
                                <h4 className="big">  <AlertCircle /> Bill Not Yet Generated</h4>
                                <label>Your bill is being prepared and will be available soon.</label>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </div>}
              </Tab.Pane>
              <Tab.Pane eventKey="unbilledTransactions">
                <AmountDetails cardId={cardId} activeTab={activeTab} />
              </Tab.Pane>
              {/* <Tab.Pane eventKey="transactionHistory">
                <AmountDetails />
              </Tab.Pane> */}
              <Tab.Pane eventKey="paymentHistory">
                <PaymentDetails cardId={cardId} activeTab={activeTab} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </section>
      {show &&
        <PaynowModal
          show={show}
          handleClose={() => setShow(false)}
          cardId={cardId}
        />}
    </>
  );
};

export default CardStatement;
